import utils from './utils'

export function preMonth(monthText) {
  const now = monthText ? new Date(`${monthText}-01`) : new Date()
  now.setMonth(now.getMonth() - 1)
  return utils.dateFormat(now, 'YY-MM')
}
export function nextMonth(monthText) {
  const now = monthText ? new Date(`${monthText}-01`) : new Date()
  let current
  if (now.getMonth() === 11) {
    current = new Date(now.getFullYear() + 1, 0, 1)
  } else {
    current = new Date(now.getFullYear(), now.getMonth() + 1, 1)
  }
  return utils.dateFormat(current, 'YY-MM')
}

export function dateHM(timestamp) {
  return utils.dateFormat(timestamp * 1000, 'YY年MM月DD日 hh:mm')
}

//往后推几个整月(ps:往后推1个月，当前2.8号，返回 3.31)
export function nextWholeMonth(date, monthNum) {
  date.setMonth(date.getMonth() + monthNum + 1)
  date.setDate(1)
  date.setDate(0)
  return date
}
